<template>
  <div>
    <div class="card mb-5 mb-3">
      <div class="card-header">
        <h3 class="card-title flex-row"><i class="fa fa-list"></i> <span class="card-label fs-3 ms-1">Quản lý
            cuộc họp</span></h3>
      </div>
      <div class="card-body">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6" v-if="userTypeId == 1">
            <label>Chủ trì:</label>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-select v-model="search.cChuTri" filterable>
                  <el-option v-for="item in userList" :key="item.nMaTaiKhoan" :label="item.cHoTen"
                    :value="item.cTenTaiKhoan" filterable></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <label>Trạng thái:</label>
            <el-row :gutter="10">
              <el-col :xs="20" :sm="22" :md="20" :lg="20" :xl="22">
                <el-select placeholder="Tất cả" v-model="search.nTinhTrang">
                  <el-option label="Tất cả" value="-1"></el-option>
                  <el-option label="Hoạt động" value="1"></el-option>
                  <el-option label="Đã xóa" value="0"></el-option>
                </el-select>
              </el-col>
              <el-col :xs="4" :sm="2" :md="4" :lg="4" :xl="2">
                <el-button plain type="primary" title="Tìm kiếm" @click="handleFindPage"><i
                    class="fa fa-search"></i></el-button>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>

    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div class="body-function">
          <div class="col-md-6">
            <el-button plain type="primary" outline native-type="submit" @click="handleOpenAdd">
              <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
              <span class="btn-inner--text">&nbsp;Thêm cuộc họp</span>
            </el-button>
          </div>
          <!-- <div class="col-md-6" style="text-align:right">
              <el-button plain icon="el-icon-refresh" size="small" style="margin-right:30px" title="Đồng bộ" type="warning" @click=""
                v-loading.fullscreen.lock="isLoading"></el-button>
            </div> -->
        </div>
      </div>
      <div class="card-body">
        <div class="col-md-12 tbl">
          <el-table :data="tableData.content" header-row-class-name="thead-light" style="height: 100%" height="100%" fit
            stripe highlight-current-row>
            <el-table-column prop="nMaCuocHop" label="Mã" width="70" align="center"></el-table-column>
            <el-table-column prop="cChuTri" label="Chủ trì" width="100" header-align="center">

            </el-table-column>
            <el-table-column prop="cThamGia" label="Tham gia" header-align="center" min-width="150">
            </el-table-column>
            <el-table-column prop="cNoiDung" label="Nội dung" header-align="center" min-width="150">
            </el-table-column>
            <el-table-column prop="cDiaDiem" label="Địa điểm" min-width="100" align="center">
            </el-table-column>
            <el-table-column prop="dThoiGian" label="Thời gian" width="150" align="center">
              <template #default="scope">
                <span v-if="scope.row.dThoiGian">{{
                  momentTime(scope.row.dThoiGian)
                }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="cKetLuan" label="Kết luận" width="100" header-align="center">
            </el-table-column>
            <el-table-column prop="nTinhTrang" label="Trạng thái" width="120" align="center">
              <template #default="scope">
                <el-tag type="success" v-if="scope.row.nTinhTrang == 1" size="small">Hoạt Động</el-tag>
                <el-tag type="danger" v-if="scope.row.nTinhTrang == 0" size="small">Đã xóa</el-tag>
              </template>
            </el-table-column>
            <!-- Button hành động -->
            <el-table-column label="Hành động" align="center" width="180">
              <template #default="scope">
                <el-button plain type="success" :disabled="scope.row.nTinhTrang == 0" data-bs-toggle="modal"
                  data-bs-target="#modal_news" @click="handleOpenConclude(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-check"></i></span>
                </el-button>
                <el-button plain type="primary" :disabled="scope.row.nTinhTrang == 0"
                  @click="handleOpenEdit(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-edit"></i></span>
                </el-button>
                <el-button plain type="danger" :disabled="scope.row.nTinhTrang == 0"
                  v-loading.fullscreen.lock="isLoading" @click="handleDelete(scope.row)">
                  <span class="btn-inner--icon"><i class="fas fa-trash"></i></span>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
          :current-page.sync="tableData.pageNum" :page-sizes="[5, 10, 20, 30, 40]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>

    <el-dialog v-model="modalVisible" :show-close="false" class="p-0  d-block h-auto mw-850px w-100">

      <template #header="{ close, titleId, titleClass }">
        <div class="d-flex justify-content-between px-4 pt-4">
          <h2 class="fw-bolder">{{ !operation ? "Thêm tiện ích" : "Cập nhật tiện ích" }}</h2>
          <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" @click="handleClose">
            <span class="svg-icon svg-icon-1">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
      </template>

      <div class="modal-body py-4">
        <el-form :model="formData" :rules="rules" ref="formData" label-width="150px" class=" d-flex flex-column">
          <el-form-item label="Chủ trì" prop="cChuTri">
            <el-select v-model="formData.cChuTri" filterable>
              <el-option v-for="item in userList" :key="item.nMaTaiKhoan" :label="item.cHoTen"
                :value="item.cTenTaiKhoan" filterable></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Nội dung" prop="cNoiDung">
            <el-input v-model="formData.cNoiDung" type="textarea" />
          </el-form-item>
          <el-form-item label="Địa điểm" prop="cDiaDiem">
            <el-input v-model="formData.cDiaDiem" />
          </el-form-item>
          <el-form-item label="Thời gian" prop="dThoiGian">
            <el-date-picker @click.stop v-model="formData.dThoiGian" type="datetime" ref="dateTimePickerRef" />
          </el-form-item>
          <el-form-item label="Tham gia" prop="cThamGia">
            <el-transfer v-model="formData.thamGia" :right-default-checked="formData.thamGia"
              style="text-align: left; display: inline-block" filterable :titles="['Chọn nhân viên', 'Đã chọn']"
              :button-texts="['', '']" :format="{
                noChecked: '${total}',
                hasChecked: '${checked}/${total}',
              }" :data="transferData">
            </el-transfer>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="modal-footer">
          <div class="btn-group">
            <el-button plain v-if="!operation" type="primary" v-loading.fullscreen.lock="isLoading"
              @click="handleSave">Thêm</el-button>
            <el-button plain v-if="operation" type="primary" v-loading.fullscreen.lock="isLoading"
              @click="handleSave">Lưu</el-button>
            <el-button plain type="danger" @click="handleClose">Thoát</el-button>
          </div>
        </div>
      </template>

    </el-dialog>

    <el-dialog v-model="conclusionVisible" :show-close="false" class="p-0  d-block h-auto mw-850px w-100">

      <template #header="{ close, titleId, titleClass }">
        <div class="d-flex justify-content-between px-4 pt-4">
          <h2 class="fw-bolder">Kết luận</h2>
          <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal"
            @click="handleClose">
            <span class="svg-icon svg-icon-1">
              <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
      </template>

      <div class="modal-body py-4">
        <el-form :model="formData" :rules="rules" ref="formData" label-width="150px" class=" d-flex flex-column">
          <el-form-item label="Kết luận" prop="cKetLuan">
            <el-input v-model="formData.cKetLuan" type="textarea" />
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <div class="modal-footer">
          <div class="btn-group">
            <el-button plain v-if="!operation" type="primary" v-loading.fullscreen.lock="isLoading"
              @click="handleSave">Thêm</el-button>
            <el-button plain v-if="operation" type="primary" v-loading.fullscreen.lock="isLoading"
              @click="handleSave">Lưu</el-button>
            <el-button plain type="danger" @click="handleClose">Thoát</el-button>
          </div>
        </div>
      </template>

    </el-dialog>
  </div>
</template>
<script>
import { Meetings } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { baseUrl } from "@/utils/global";
import { CookieComponent } from "@/assets/ts/components";
import { ElMessage } from "element-plus";
export default {
  name: 'meeting',
  data() {
    return {
      search: {
        cChuTri: "",
        nTinhTrang: "-1",
      },
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1,
        type: 1
      },
      formData: {
        cChuTri: "",
        cThamGia: "",
        cNoiDung: "",
        thamGia: []
      },
      rules: {
        cTen: [{ required: true, message: "Xin vui lòng điền tên cuộc họp", trigger: "blur" }],
      },
      tableData: {
      },
      isLoading: false,
      modalVisible: true,
      conclusionVisible: false,
      operation: false,
      iframeURL: "",
      openIframe: false,
      isSearchLoading: false,
      store: useStore(),
      baseUrl: baseUrl,
      userList: [],
      isDatePickerOpen: false
    }
  },
  computed: {
    userTypeId() {
      return CookieComponent.get("userTypeId")
    },
    transferData() {
      return this.userList.filter(val => { return val.cTenTaiKhoan != this.formData.cChuTri }).map(val => { return { key: val.cTenTaiKhoan, label: val.cHoTen } })
    },
  },
  methods: {
    handleChangePageNum(val) {
      this.pageRequest.pageNum = val
      this.handleFindPage()
    },
    handleChangePageSize(val) {
      this.pageRequest.pageSize = val
      this.handleFindPage()
    },
    handleOpenAdd() {
      this.modalVisible = true
      this.$nextTick(() => {
        this.$refs.formData.resetFields()
        this.operation = false
        this.$nextTick(() => {
          this.formData = {}
        })
      })

    },
    handleOpenEdit(val) {
      this.modalVisible = true
      this.$nextTick(() => {
        this.$refs.formData.resetFields()
        this.operation = true
        this.$nextTick(() => {
          this.formData = Object.assign({}, val)
        })
      })
    },
    handleOpenConclude(val) {
      this.conclusionVisible = true
      this.$nextTick(() => {
        this.$refs.formData.resetFields()
        this.operation = true
        this.$nextTick(() => {
          this.formData = Object.assign({}, val)
        })
      })
    },
    handleClose() {
      this.modalVisible = false
      this.conclusionVisible = false
      /* hideModal(this.$refs.cuộc họpModalRef) */
    },
    handleDelete(val) {
      this.$confirm("Bạn có muốn xóa cuộc họp này không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.store.dispatch(Meetings.deleteMeetings, val).then(res => {
            if (res.code == 200) {
              ElMessage({ message: "Xóa cuộc họp thành công", type: "success" });
              this.handleFindPage()
            } else {
              ElMessage({ message: res.msg, type: "error" });
            }
          }).catch((error) => {
            ElMessage({ message: "Xóa cuộc họp thất bại", type: "error" });
          })
        }).catch(() => {

        })
    },
    handleCLoseIframe() {
      this.openIframe = false
      this.iframeURL = ""
    },
    handleFindPage() {
      this.pageRequest.columnFilters = {
        cChuTri: { value: this.search.cChuTri },
        nTinhTrang: { value: this.search.nTinhTrang },
      }
      this.store.dispatch(Meetings.findPageMeetings, this.pageRequest).then(res => {
        if (res.code == 200) {
          this.tableData = {
            ...res.data, content: res.data.content.map(val => {
              return { ...val, thamGia: val.cThamGia.split(",") }
            })
          }
        }
      })

    },
    handleListUser() {
      this.store.dispatch(Meetings.listUser).then(res => {
        this.userList = []
        if (res.code == 200) {
          this.userList = res.data
        }
      })
    },
    handleSave() {
      this.$refs.formData.validate((valid) => {
        if (valid)
          this.$confirm("Bạn có muốn lưu cuộc họp này không?", "Xác nhận", {
            confirmButtonText: "Xác nhận",
            cancelButtonText: "Hủy",
            type: "warning",
          })
            .then(() => {
              if (this.operation) {

                this.store.dispatch(Meetings.updateMeetings, this.formData).then(res => {
                  if (res.code == 200) {
                    ElMessage({ message: "Cập nhật cuộc họp thành công", type: "success" })
                    this.handleFindPage()
                    this.handleClose()
                  } else {
                    ElMessage({ message: "Cập nhật cuộc họp không thành công", type: "error" })
                  }
                }).catch(() => {
                  ElMessage({ message: "Cập nhật cuộc họp không thành công", type: "error" })
                })
              } else {
                this.store.dispatch(Meetings.insertMeetings, this.formData).then(res => {
                  if (res.code == 200) {
                    ElMessage({ message: "Lưu cuộc họp thành công", type: "success" })
                    this.handleFindPage()
                    this.handleClose()
                  } else {
                    ElMessage({ message: "Lưu cuộc họp không thành công", type: "error" })
                  }
                }).catch(() => {
                  ElMessage({ message: "Lưu cuộc họp không thành công", type: "error" })
                })
              }
            }).catch(() => {

            })
      })
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    },
    momentTime(val) {
      return val ? moment(val).format("DD/MM/YYYY HH:MM") : ""
    }
  },
  mounted() {
    this.modalVisible = false
    this.handleFindPage()
    this.handleListUser()
  },

};
</script>
<style lang="scss"></style>